
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CanActivateGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private router: Router, private authService: AuthService){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkLogging(state.url);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  canLoad(route: import("@angular/router").Route, segments: import("@angular/router").UrlSegment[]): boolean | Observable<boolean> | Promise<boolean> {
    const url = `/${route.path}`;
    return this.checkLoggingForLoad(url);
  }

  private checkLogging(url: string) {
    console.log('checkLogging - LLENDO A:', url);
    if (this.authService.isLoggedIn()) {
      console.log('checkLogging - isLoggedIn: true');
      return of(true);
    }
    console.log('checkLogging - isLoggedIn: false');
    return this.authService.tryRefreshToken().pipe(
      map(login => {
        console.log('checkLogging - tryRefreshToken: ', login);
        if (login) return true; // Refrescó correctamente
        this.authService.urlUsuarioIntentaAcceder = url;
        return this.router.parseUrl('/login');
      }),
      catchError(() => {
        console.log('checkLogging - catchError: ', url);
        this.authService.urlUsuarioIntentaAcceder = url;
        return of(this.router.parseUrl('/login'));
      })
    );
    // return new Promise<boolean>(resolve => {
    //   this.authService.tryRefreshToken().subscribe({
    //     next: () => {
    //       this.authService.urlUsuarioIntentaAcceder = url;
    //       resolve(true)
    //     },
    //     error: () => {
    //       this.authService.urlUsuarioIntentaAcceder = url
    //       // No borrar storage aquí. Solo redirigir si corresponde.
    //       if (url !== '/login') {
    //         this.router.navigate(['/login']); // opcional
    //       }
    //       resolve(false);
    //     }
    //   });
    // });
  }

  private checkLoggingForLoad(url: string): Observable<boolean> | boolean {
    console.log('LLENDO A (canLoad):', url);
    if (this.authService.isLoggedIn()) return true;
  
    return this.authService.tryRefreshToken().pipe(
      map(login => {
        if (login) return true;
        this.router.navigate(['/login']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }

}
